<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="true"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in menuTree"
          :key="route.ID"
          :item="route"
          :base-path="route.path"
        />
        <!-- <sidebar-item
          v-for="route in $router.options.routes"
          :key="route.ID"
          :item="route"
          :base-path="route.path"
        /> -->
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import { initMenu } from "../../../utils/permission";

export default {
  components: { SidebarItem, Logo },
  created() {
    // console.log(this.$store.getters.menuTree);
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar"]),
    ...mapGetters(["users", "menuTree"]),
    routes() {
      return this.$router.options.routes;
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>

<style scoped>
.has-logo {
  width: 200px;
}
.el-menu {
  padding-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue